import { useBuilderWidget } from 'components/TasksV2/TaskCreation/contexts/BuilderWidgetContext'
import { useCreationText } from 'components/TasksV2/TaskCreation/hooks/useCreationText'
import { Flex, Text } from '@chakra-ui/core'
import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import useLocaleText from 'components/useLocaleText'
import colors from 'constants/colors'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

interface Props {
  subtaskPath: string
  compact?: boolean
}

export const WidgetIsRequiredSwitch: React.FC<Props> = ({ subtaskPath, compact = false }) => {
  const builder = useBuilderWidget()
  const t = useCreationText()
  const { control, setValue, watch } = useFormContext()
  const is_required = useLocaleText('required')
  const requiredPath = `${subtaskPath}.is_required`
  const requiredValue = watch(requiredPath)

  return (
    <Flex
      className={builder ? (compact ? 'creation-required-header' : 'creation-required-row') : undefined}
      w={compact ? 'auto' : '100%'}
      alignItems="center"
      justifyContent="flex-end"
      style={{ columnGap: '10px' }}
    >
      {builder ? (
        <div>
          <strong>{t.requiredSubtask}</strong>
          {!compact && <p>{t.requiredHint}</p>}
        </div>
      ) : (
        <Text color={colors.analyticGrey} fontSize="12px">
          {is_required}
        </Text>
      )}
      {compact ? (
        <ControlledCustomSwitch
          name={requiredPath}
          isChecked={requiredValue ?? true}
          size="sm"
          aria-label={builder ? t.requiredSubtask : is_required}
          onChange={(event) => setValue(requiredPath, event.target.checked)}
        />
      ) : (
        <Controller
          as={ControlledCustomSwitch}
          name={`${subtaskPath}.is_required`}
          control={control}
          defaultValue={true}
          valueName="isChecked"
          size="sm"
          aria-label={builder ? t.requiredSubtask : is_required}
          onChange={([event]) => {
            const newValue = event.target.checked

            setValue(`${subtaskPath}.is_required`, newValue)
            return newValue
          }}
        />
      )}
    </Flex>
  )
}
